import { render } from "./Account.vue?vue&type=template&id=af545b92&scoped=true"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"

import "./Account.vue?vue&type=style&index=0&id=af545b92&lang=css"
import "./Account.vue?vue&type=style&index=1&id=af545b92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af545b92"]])

export default __exports__